import { hasMandatoryHostedConfig } from './configHelpers';

export const buildHostedConfigFromAppAssets = fetchedAppAssets => {
  if (!fetchedAppAssets) {
    return {};
  }

  const { translations: _translations, ...rest } = fetchedAppAssets;
  return Object.entries(rest).reduce((collectedData, [name, content]) => {
    return { ...collectedData, [name]: content?.data || {} };
  }, {});
};

export const buildTranslationsFromAppAssets = fetchedAppAssets =>
  fetchedAppAssets?.translations?.data || {};

/**
 * Resolve hosted config + translations for client bootstrap.
 * Falls back to SSR snapshot when CDN fetch fails or returns incomplete config
 * (e.g. transient ERR_CONNECTION_CLOSED after external redirects like Stripe).
 */
export const resolveClientHostedBootstrap = (fetchedAppAssets, ssrSnapshot = {}) => {
  const hostedConfigFromFetch = buildHostedConfigFromAppAssets(fetchedAppAssets);
  const translationsFromFetch = buildTranslationsFromAppAssets(fetchedAppAssets);

  const ssrHostedConfig = ssrSnapshot.hostedConfig || {};
  const ssrTranslations = ssrSnapshot.translations || {};

  const fetchHasMandatory = hasMandatoryHostedConfig(hostedConfigFromFetch, { logMissing: false });
  const ssrHasMandatory = hasMandatoryHostedConfig(ssrHostedConfig, { logMissing: false });
  const usedSsrFallback = !fetchHasMandatory && ssrHasMandatory;

  return {
    hostedConfig: usedSsrFallback ? ssrHostedConfig : hostedConfigFromFetch,
    translations: usedSsrFallback ? ssrTranslations : translationsFromFetch,
    usedSsrFallback,
    fetchFailed: !fetchedAppAssets,
    fetchHasMandatory,
    ssrHasMandatory,
  };
};
